/* eslint-disable @typescript-eslint/no-empty-function */
import BaseFoundation from '../base/foundation';
export default class PopConfirmFoundation extends BaseFoundation {
  init() {}

  destroy() {}

  handleCancel(e) {
    this._adapter.notifyCancel(e);

    this.handleVisibleChange(false);
  }

  handleConfirm(e) {
    this._adapter.notifyConfirm(e);

    this.handleVisibleChange(false);
  }

  handleClickOutSide(e) {
    this._adapter.notifyClickOutSide(e);
  }

  handleVisibleChange(visible) {
    if (!this._isControlledComponent('visible')) {
      this._adapter.setVisible(visible);
    }

    this._adapter.notifyVisibleChange(visible);
  }

}